module.exports = __webpack_public_path__ + "static/media/memory_3.066a6713.png";